import { type ButtonHTMLAttributes } from 'react';
import clsx from 'clsx';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-accent-dim border-accent/15 text-accent animate-cta-idle hover:scale-[1.015] hover:shadow-[0_0_10px_#00c85333] hover:border-accent/27 hover:bg-accent/13',
  secondary: 'bg-input-bg border-panel-border text-text-muted hover:text-text-bright hover:border-panel-border-hi',
  ghost: 'bg-transparent border-transparent text-text-muted hover:text-text-bright hover:bg-accent-faint',
  danger: 'bg-danger-dim border-danger/15 text-danger hover:bg-danger/13',
};

export function Button({ variant = 'secondary', className, children, ...props }: ButtonProps) {
  return (
    <button
      className={clsx(
        'px-6 py-3.5 border rounded-[3px] font-mono text-sm font-semibold tracking-[0.3px] cursor-pointer',
        'transition-all duration-300 ease-[cubic-bezier(0.2,0,0,1)]',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        variants[variant],
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
